import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { setUser } from "@/redux/auth/actions";
import api from "@/services/api";
import Birthday from "@/layout/header/Birthday";
import { classNames } from "@/utils";
import CommandPalette from "@/layout/header/CommandPalette";

export default function SelecoleHeader() {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { user, app } = useSelector((state) => state.Auth);
  const location = useLocation();

  if (location.pathname.indexOf("/auth") !== -1) return null;

  async function logout() {
    await api.post(`/user/logout`);
    dispatch(setUser(null));
  }

  const menuStyling = {
    menuOpacity: `${open ? "opacity-10" : "opacity-0"}`,
    menuVisibility: `${open ? "block p-4 sm:p-0" : "hidden"}`,
    menuTransition: `${open ? "translate-x-0" : "translate-x-[105%]"}`,
  };

  return (
    <header className="sticky top-0 py-2 bg-white border-b border-slate-300 flex justify-between items-center w-full right-4 z-40 px-3">
      <div className="flex items-center">{user && app === "accounting" ? <CommandPalette /> : null}</div>
      <div className="flex items-center gap-8">
        <div className="hidden sm:block">{app === "accounting" && <Birthday />}</div>
        <div className="relative flex gap-2">
          <div className="relative my-auto" onClick={() => setOpen(!open)}>
            <img className="min-w-[32px] w-9 sm:h-9 bg-[#aaa] rounded-full cursor-pointer object-cover" src={user.avatar} />
          </div>
          <div
            className={`w-screen md:w-[200px] h-screen md:h-fit rounded overflow-hidden z-0 bg-[#fff] 
          ${menuStyling.menuVisibility} transition duration-100 ease-in fixed top-0 right-0  md:absolute md:top-[calc(100%_+_10px)] z-50 md:z-10 shadow-menuShadow `}
            open={open}>
            <div className="text-3xl mt-3 cursor-pointer	text-[#666] block w-[45px] py-0	px-3.5	ml-auto	md:hidden " onClick={() => setOpen(false)}>
              &times;
            </div>
            <div className="p-2 border-b border-gray-200 text-xs">
              <p className="font-semibold">{user.name}</p>
              <p className="text-gray-500 italic">{user.email}</p>
            </div>
            <div className="text-sm text-left text-black cursor-pointer hover:bg-blue-100 p-2">
              <Link to="/account">My account</Link>
            </div>
            {/* {user.role === "admin" && (
              <div className="text-sm text-left text-black cursor-pointer hover:bg-blue-100 p-2">
                <Link to={`/organisation/${user.organisation_id}`}>My Organisation</Link>
              </div>
            )} */}
            <div className="text-sm text-left text-black cursor-pointer hover:bg-red-100 p-2" onClick={logout}>
              Logout
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
